import api from '../api'

//data
const state = {
  status:{
    loading:false,
    loaded:false,
    error:'', // last error
    lastLoaded:''
  },
  items:[],
  cartitems:[],
  order:{
  },
  details:{},
  unconfirmed:{}
}

//comuted store.getters.inCart
const getters = {

}

//sync methods store.commit('increment')
const mutations = {

  LOADING_ORDER (state, isLoading){
    state.status.loading = isLoading
  },

  SET_ORDER (state, data){
    state.items = data
  },

  SET_ORDER_DATA (state, data){
    state.order = data
  },

  REMOVE_ORDER_ITEM (state, item){
    var items = JSON.parse(JSON.stringify(state.items)); //without copying it will not work
    var index = state.items.findIndex(o => o.id === item.id);
    if(index >=0){

      items.splice(index, 1)
      state.items = items; //update by index will not work
    }
    else console.error('Item not found in Order Store state')

  },

  SET_ORDER_ITEMS (state, data){
    state.cartitems = data
  },

  SET_ORDER_DETAILS(state, details) {
    state.details = details
  },

  ADD_ORDER_ITEM_CART(state,item){
    state.cartitems.push(item)
  },

  UPDATE_ORDER_ITEM_CART(state,item){
    var items = JSON.parse(JSON.stringify(state.cartitems)); //without copying it will not work
    var index = state.cartitems.findIndex(o => o.id === item.id);
    if(index >=0){
      items[index] = item
      state.cartitems = items; //update by index will not work
    }
    else console.error('Item not found in cart Store state')

  },

  REMOVE_ORDER_ITEM_CART (state, item){
    var items = JSON.parse(JSON.stringify(state.cartitems)); //without copying it will not work
    var index = state.cartitems.findIndex(o => o.id === item.id);
    if(index >=0){
      items.splice(index, 1)
      state.cartitems = items; //update by index will not work
    }
    else console.error('Item not found in cart Store state')


  },

  SET_UNCONFIRMED_ORDERS (state, items){

      state.unconfirmed = items;
  },
}

//async methods  store.dispatch('increment')
const actions = {


  loadOrderWaitingForDelivery ({state, commit}) {

    commit('LOADING_ORDER', true);
    //no need for return here
     return api.get('order/ordersinprogress')
      .then(function (response) {
        commit('SET_ORDER', response.data.order)
        commit('LOADING_ORDER', false);
        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_ORDER', false);
        return Promise.reject(error);

      });
  },

  loadOrder({state, commit},orderId){

    commit('LOADING_ORDER', true);

    return api.get('order/'+orderId)
      .then(function (response) {

        commit('SET_ORDER_DATA', response.data.order)
        commit('LOADING_ORDER', false);
        return Promise.resolve(response);
      })
      .catch(function (error) {

        commit('LOADING_ORDER', false);
        commit('SET_ORDER_DATA', '')
        return Promise.reject(error);

      });
  },

  loadUnconfirmedOrders({state, commit},orderId){

    commit('LOADING_ORDER', true);
    commit('SET_UNCONFIRMED_ORDERS',{});

    return api.get('order/unconfirmed')
      .then(function (response) {

        commit('SET_UNCONFIRMED_ORDERS', response.data.order)
        commit('LOADING_ORDER', false);
        return Promise.resolve(response);
      })
      .catch(function (error) {

        commit('LOADING_ORDER', false);
        commit('SET_UNCONFIRMED_ORDERS', {})
        return Promise.reject(error);

      });
  },

  updateOrder({state, commit},order){

    commit('LOADING_ORDER', true);

    return api.post('order/'+order.id, order)
      .then(function (response) {

        commit('SET_ORDER_DATA', response.data.order)
        commit('LOADING_ORDER', false);
        return Promise.resolve(response);
      })
      .catch(function (error) {

        commit('LOADING_ORDER', false);
        commit('SET_ORDER_DATA', '')
        return Promise.reject(error);

      });
  },

  deleteOrder({state, commit},order){

    commit('LOADING_ORDER', true);

    return api.delete('order/'+order.id, order)
      .then(function (response) {
        commit('REMOVE_ORDER_ITEM', order)
        commit('LOADING_ORDER', false);
        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_ORDER', false);
        return Promise.reject(error);

      });
  },

  convertOrderToCart ({state, commit},order) {
 
    //commit('LOADING_CART', true);
    var data= { status: 0}
    return api.post('order/'+order.id+'/converttocart',data)
      .then(function (response) {

        return Promise.resolve(response);
      })
      .catch(function (error) {

        return Promise.reject(error);
       });
    },


//reuse cart functionality
  loadOrderDetails(context, id) {

    context.commit('LOADING_ORDER', true);
    return api.get('cart/order/'+id)
      .then(function(response) {
        context.commit('SET_ORDER_DETAILS', response.data.data)
        context.commit('LOADING_ORDER', false);

        return Promise.resolve(response);
      })
      .catch(function(error) {
        context.commit('LOADING_ORDER', false);
        console.log(error);
        return Promise.reject(error);
      });

  },

  //reuse cart
  loadOrderItems(context, id) {
    context.commit('LOADING_ORDER', true);
    return api.get('cart/'+id+'/item')
      .then(function(response) {

        context.commit('SET_ORDER_ITEMS', response.data.data) //SET_ORDER_ITEMS
        context.commit('LOADING_ORDER', false);
        return Promise.resolve(response);
      })
      .catch(function(error) {
        context.commit('LOADING_ORDER', false);
        console.log(error);
        return Promise.reject(error);
      });

  },

  processCartOrder(context, [order,changeAutoship]) {

      context.commit('LOADING_ORDER', true);
      return api.post('cart/order/'+order.id+'/processcart', changeAutoship)
        .then(function(response) {
          context.commit('SET_ORDER_DETAILS', response.data.order)
          context.commit('LOADING_ORDER', false);
          return Promise.resolve(response);
        })
        .catch(function(error) {
          context.commit('LOADING_ORDER', false);
          console.log(error);
          return Promise.reject(error);
        });

    },

    deleteOrderCart(context, order) {

        context.commit('LOADING_ORDER', true);
        return api.delete('cart/order/'+order.id+'')
          .then(function(response) {
            return Promise.resolve(response);
          })
          .catch(function(error) {
            context.commit('LOADING_ORDER', false);
            console.log(error);
            return Promise.reject(error);
          });

      },


  //reuse autoship
  updateCartOrder(context, order) {

          //verify if order has changed and date is set
          if (state.details.address_id == order.address_id
            && state.details.delivery_date == order.delivery_date
            && state.details.notes == order.notes
            && state.details.payment_type == order.payment_type
            && order.delivery_date == ""
            ) return;

          context.commit('LOADING_ORDER', true);
          return api.post('cart/'+order.id, order)
            .then(function(response) {
              context.commit('SET_ORDER_DETAILS', response.data.data)
              context.commit('LOADING_ORDER', false);
              return Promise.resolve(response);
            })
            .catch(function(error) {
              context.commit('LOADING_ORDER', false);
              console.log(error);
              return Promise.reject(error);
            });

    },


    //add or update
    addOrderItem ({state, commit},[cartId, item]) {

      //commit('LOADING_CART', true);

      return api.post('cart/'+cartId+'/cartitem', item)
        .then(function (response) {
          if(item.id && item.order == 0 && item.return == 0){
            commit('REMOVE_ORDER_ITEM_CART', response.data.data)
          }
          else if(item.id){
            commit('UPDATE_ORDER_ITEM_CART', response.data.data)
          }
          else commit('ADD_ORDER_ITEM_CART', response.data.data)

          return Promise.resolve(response);

        })
        .catch(function (error) {
        //  commit('LOADING_CART', false);
          return Promise.reject(error);


        });
    },



    removeOrderItem ({state, commit},item) {

      commit('LOADING_ORDER', true);

      return api.delete('cart/' + item.cart_id + '/item/'+ item.good_id)
        .then(function (response) {

           commit('REMOVE_ORDER_ITEM_CART', item)
           commit('LOADING_ORDER', false);
           return Promise.resolve(response);

        })
        .catch(function (error) {
          commit('LOADING_ORDER', false);
          return Promise.reject(error);


        });
    },







}


export default {
  state, mutations, actions, getters
}



// WEBPACK FOOTER //
// ./src/store/modules/OrderStore.js